import React from 'react';

import { cn } from 'lib/utils';

interface ConfigurationHeaderProps {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  titleClassName?: string;
  subtitleClassName?: string;
}

function ConfigurationHeader({
  title,
  subtitle,
  icon,
  badge,
  titleClassName,
  subtitleClassName,
}: ConfigurationHeaderProps) {
  if (!icon && !title && !subtitle && !badge) {
    return null;
  }

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-3 sm:max-w-[604px]">
      {(icon || title || badge) && (
        <div className="flex min-w-0 items-center gap-2">
          {icon}
          {title && (
            <h1
              className={cn(
                'min-w-0 text-xl 2xl:text-2xl font-medium leading-[1.2] text-[#3d3d3d] dark:text-foreground',
                titleClassName,
              )}
            >
              {title}
            </h1>
          )}
          {badge}
        </div>
      )}
      {subtitle && (
        <p
          className={cn(
            'min-w-0 text-sm 2xl:text-base font-normal leading-[1.6] text-[#4f4f4f] dark:text-muted-foreground',
            subtitleClassName,
          )}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}

export default ConfigurationHeader;
